// extracted by mini-css-extract-plugin
export default {"backgroundChartCategoryMobile":"ChartCategoryMobile_backgroundChartCategoryMobile__ZIeBS"};